<template>
  <Layout :backToRoute="false" :removePadding="true">
    <div v-if="userData">
      <div class="primary--text section-title font-weight-bold px-8">
        <icon
          :name="'receive_cash'"
          :color="this.$vuetify.theme.themes.light.primary"
          width="30"
        ></icon>
        <span style="color: var(--primary-color-blue);">
          {{ $t("balance_refund.title") }}
        </span>
      </div>
      <v-row
        style="background: #0002300D;"
        class="d-flex flex-grow-0 mb-4 px-10 justify-space-between py-5 align-center mt-n2"
      >
        <span style="font-size: 18px; font-weight: 500;">{{ $t("balance_refund.current_balance") }}</span>
        <span class="font-weight-bold title"
          ><span class="display font-weight-bold"
            >{{ whole(userData.balance) }},</span
          >{{ decimal(userData.balance) }}
          <v-icon color="#000230" style="font-size: 15px">{{
            currency_symbol
          }}</v-icon></span
        >
      </v-row>
      <div class="d-flex flex-column align-center px-12 pt-12">
        <v-row>
          <div style="color: var(--primary-color-blue); font-size: 18px; font-weight: 500;">
            {{ $t("balance_refund.refundable_balance") }}
          </div>
        </v-row>
        <v-row class="py-6">
          <span style="color: var(--primary-color-blue);" class="display-2 font-weight-bold">
            {{ whole(userData.refundableBalance) }},<span class="display"
              >{{ decimal(userData.refundableBalance)
              }}<v-icon color="#000230">{{ currency_symbol }}</v-icon></span
            >
          </span>
        </v-row>
        <v-row class="pt-4">
          <v-btn
            class="py-8 semi-rounded"
            color="#000230"
            x-large
            :loading="sendingRequest"
            :disabled="!Number(userData.refundableBalance)"
            @click="requestRefund"
          >
            <span style="color: white;">
              {{ $t("balance_refund.confirm_action") }}
            </span>
          </v-btn>
        </v-row>
      </div>
    </div>
    <RefundDialog v-if="refundAlert" />
  </Layout>
</template>
<script>
import Layout from "@/views/layouts/MainLayout";
import { whole, decimal } from "../utils/MoneyUtils";
import { mapState } from "vuex";
import RefundDialog from "@/components/dialogs/RefundWarningDialog";
import { RequestService } from "../services/request.service";
import RedirectHandler from "@/mixins/RedirectHandler";
const requestService = new RequestService();

export default {
  props: ["routeNames"],
  data() {
    return {
      refund: {},
      sendingRequest: false,
    };
  },
  mixins: [RedirectHandler],
  components: {
    Layout,
    RefundDialog,
  },
  methods: {
    whole,
    decimal,
    requestRefund() {
      const context = this;
      this.sendingRequest = true;
      requestService
        .requestRefund(context)
        .then(() => {
          this.requestRefundSuccess();
        })
        .catch(() => {
          context.sendingRequest = false;
        });
    },
    requestRefundSuccess() {
      const action = "request-refund";
      const viewData = {
        title: {
          icon: "receive_cash",
          text: "balance_refund.title",
        },
        primary_text: {
          vicon: "check_circle",
          text: "balance_refund.success_refund.primary_text",
        },
        secondary_text: "balance_refund.success_refund.secondary_text",
      };
      this.successRedirect(action, viewData);
    },
  },
  computed: {
    ...mapState({
      userData: (state) => state.userData.userData,
      currency_symbol: (state) =>
        state.customization.customization.economics.currency_symbol,
      refundAlert: (state) => (state.userData.balance !== state.userData.refundableBalance) || !state.userData.refundableBalance >= 0 ? true : false
    }),
  },
  mounted() {
    if (!this.userData) requestService.getUserData(this);
  },
};
</script>
